import { render, staticRenderFns } from "./RetailerAI.vue?vue&type=template&id=03358a40&scoped=true&"
import script from "./RetailerAI.vue?vue&type=script&lang=js&"
export * from "./RetailerAI.vue?vue&type=script&lang=js&"
import style0 from "./RetailerAI.vue?vue&type=style&index=0&id=03358a40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03358a40",
  null
  
)

export default component.exports